<template>
  <div style="background-color: #F5F6F8; height: 100vh;">
    <div class="container mx-auto">
      <div
        style="height: 60px;"
        class="d-flex align-items-center ps-2"
      >
        <div
          v-if="step>0 && step<4"
          style="font-size: 1.2rem;"
        >
          <i
            v-if="step>1"
            class="fa-solid fa-angle-left px-3 py-2 text-center"
            style="color:#011638;"
            @click="transitionDirection = 'slide-backward';step--"
          />
          <span
            class="ms-1"
            style="color: #c7cbd3"
          >
            <span style="font-weight: 900; color:#011638">{{ step }}</span> of 3
          </span>
        </div>
      </div>
      <h1
        v-if="step>0 && step<4"
        class="mb-3 mt-2 text-center"
        style="color:#394A64; font-weight: 600;"
      >
        Creating your account
      </h1>
      <div
        style="flex-grow: 1;overflow: auto;"
        class="px-2"
      >
        <transition :name="transitionDirection">
          <div v-if="step == 1">
            <p
              class="ps-3"
              style="color:#56647A"
            >
              Enter your data to continue
            </p>
            <div class="form-floating mt-4 mb-2">
              <input
                v-model="userRegister.name"
                type="text"
                class="form-control"
                placeholder="Nombre"
              >
              <label>Nombre <span class="text-danger">*</span></label>
            </div>
            <span
              v-if="try_step==1 && userRegister.name.length==0"
              class="ms-3 text-danger"
            >Rellene su nombre</span>
            <div class="form-floating mt-3 mb-2">
              <input
                v-model="userRegister.surname"
                type="text"
                class="form-control"
                placeholder="Apellido"
              >
              <label>Apellido <span class="text-danger">*</span></label>
            </div>
            <span
              v-if="try_step==1 && userRegister.surname.length==0"
              class="ms-3 text-danger"
            >Rellene su apellido</span>
            <div class="form-floating mt-3 mb-2">
              <input
                v-model="userRegister.mobile_phone"
                type="phone"
                class="form-control"
                placeholder="Phone"
              >
              <label>Teléfono <span class="text-danger">*</span></label>
            </div>
            <span
              v-if="try_step==1 && !phone_regex.test(userRegister.mobile_phone)"
              class="ms-3 text-danger"
            >Número de telefono no valido</span>
          </div>
        </transition>
        <transition :name="transitionDirection">
          <div v-if="step == 2">
            <p
              class="ps-3"
              style="color:#56647A"
            >
              Optional information
            </p>
            <div class="row m-0">
              <div
                class="circle mx-auto"
                @click="triggerFileInput"
              >
                <img
                  src="../../src/assets/camera_icon.png"
                  alt="Imagen centrada"
                >
                <input
                  ref="fileInput"
                  type="file"
                  accept="image/*"
                  style="display: none"
                  @change="handleFileChange"
                >
              </div>
              <span
                v-if="errorImg"
                class="mt-3 text-danger"
              >Tipo de archivo subido incorrecto, por favor introduzca una imagen</span>
              <p
                v-if="imagePreview"
                class="text-success mt-3"
              >
                {{ imagePreview }} <span><i
                  class="fa-solid fa-trash ps-4"
                  @click="userRegister.img = null;imagePreview = null"
                /></span>
              </p>
            </div>
            <div class="row g-2 m-0 mt-5">
              <div
                class="col btn btn-light py-3 me-1 rounded-4"
                style="color: #56647A; font-weight: 600;"
                @click="triggerCamera"
              >
                <i class="fa-solid fa-camera me-1" />
                Take a picture
              </div>
              <input
                ref="cameraInput"
                type="file"
                accept="image/*"
                capture="environment"
                style="display: none"
                @change="handleFileChange"
              >
              <div
                class="col btn btn-light py-3 ms-1 rounded-4"
                style="color: #56647A; font-weight: 600;"
                @click="triggerFileInput"
              >
                <i class="fa-regular fa-images me-1" />
                Import
              </div>
            </div>
            <div class="form-floating mt-4 mb-2">
              <input
                v-model="userRegister.birthday_date"
                type="date"
                class="form-control"
                placeholder="Date or birth"
                style="color:grey"
              >
              <label>Date of birth <span class="text-danger">*</span></label>
            </div>
            <span
              v-if="try_step==2 && (userRegister.birthday_date==null || new Date(userRegister.birthday_date) >= new Date())"
              class="ms-3 text-danger"
            >Fecha incorrecta</span>
            <div class="form-floating mt-4 mb-2">
              <input
                v-model="userRegister.description"
                type="text"
                class="form-control"
                placeholder="Descripcion"
              >
              <label>Description</label>
            </div>
          </div>
        </transition>
        <transition :name="transitionDirection">
          <div v-if="step == 3">
            <p
              class="ps-3"
              style="color:#56647A"
            >
              Enter your login information
            </p>
            <div class="form-floating mt-4 mb-2">
              <input
                v-model="userRegister.email"
                type="email"
                class="form-control"
                placeholder="email"
              >
              <label>Mail <span class="text-danger">*</span></label>
            </div>
            <span
              v-if="try_step==3 && !email_regex.test(userRegister.email)"
              class="ms-3 text-danger"
            >Email incorrecto</span>
            <div class="form-floating mt-3 mb-2">
              <input
                v-model="userRegister.password"
                type="password"
                class="form-control"
                placeholder="password"
              >
              <label>Password</label>
            </div>
            <span
              v-if="try_step==3 && userRegister.password.length<8"
              class="ms-3 text-danger"
            >La contraseña debe tener al menos 8 caracteres</span>
            <span
              v-if="userRegister.password.length>=8"
              class="ms-3 text-success"
            >
              <i class="fa-solid fa-check me-1" />
              Contraseña segura
            </span>
            <div class="form-floating mt-3 mb-2">
              <input
                v-model="password_repeted"
                type="password"
                class="form-control"
                placeholder="second pass"
              >
              <label>Confirm Password</label>
            </div>
            <span
              v-if="try_step==3 && password_repeted != userRegister.password"
              class="ms-3 text-danger"
            >Las contraseñas no coinciden</span>
          </div>
        </transition>
        <transition :name="transitionDirection">
          <div
            v-if="step == 4"
            class="h-100 d-flex align-items-center justify-content-center"
          >
            <div>
              <div class="d-flex justify-content-center mb-5">
                <img src="../../src/assets/checked-register.png">
              </div>
              <h1
                class="text-center mb-3"
                style="color: #394A64;font-weight: 600;"
              >
                Felicidades,<br>Te has registrado correctamente!
              </h1>
              <p
                class="text-center"
                style="color: #8E97A7;font-weight: 400;"
              >
                Ya puedes enviar invitaciones
              </p>
            </div>
          </div>
        </transition>
      </div>
      <div
        v-if="step>0 && step<4"
        style="height: 120px;"
      >
        <p
          v-if="error"
          class="text-danger text-center mb-2"
        >
          Ha habido un error en el registro
          <i class="fa-regular fa-face-sad-tear ms-2" />
        </p>
        <button
          class="btn py-2 w-100 rounded-3"
          style="background-color: #15E0DD; font-size: 1.1rem;font-weight: 600; color: #007B79"
          @click="NextStep"
        >
          <span v-if="step<3">Next <i
            class="fa-solid fa-angle-right ms-1"
            style="color:white;font-size: 1rem;"
          /></span>
          <span v-else>Create account</span>
        </button>
        <p class="text-center mt-2">
          Already have an account?
          <router-link
            to="/Login"
            style="cursor: pointer;color: #15E0DD;text-decoration: none;font-weight: 500"
          >
            Log in
          </router-link>
        </p>
      </div>
    </div>
    <spinner-component
      id="spinner"
      class="d-none"
    />
  </div>
</template>

<script>
  import axios from 'axios';
  import SpinnerComponent from '../components/SpinnerComponent.vue'
  import { mapState } from 'vuex';
  import router from '@/router';

  export default {
    name: 'RegisterPage',
    components:{
      SpinnerComponent
    },
    data: function() {
      return {
        userRegister: {
          name: "",
          surname: "",
          mobile_phone: "",
          img: null,
          birthday_date: null,
          description: "",
          email: "",
          password: ""
        },
        password_repeted: "",
        step:1,
        try_step: 0,
        phone_regex: /^[6789](?:\d\s?){8}$/,
        email_regex: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        transitionDirection: "slide-forward", // direccion en la que va el form
        imagePreview: null,
        errorImg: false,
        error:false
      }
    },
    computed:{
      ...mapState(['isLoggedIn']),
      ...mapState(['token']),
      ...mapState(['refresh'])
  },
  mounted() {
  },
  methods:{
    triggerCamera() {
      this.$refs.cameraInput.click();
    },
    triggerFileInput() {
      // Aseguramos que la referencia existe antes de llamar al método click()
      if (this.$refs.fileInput) {
        this.$refs.fileInput.click();
      }
    },
    handleFileChange(event) {
      const file = event.target.files[0];
      if (file) {

        if (!file.type.startsWith('image/')) {
          this.errorImg=true
          return; // Salir si no es una imagen
        }

        const reader = new FileReader();
        reader.onload = (e) => {
            this.userRegister.img = e.target.result;
            this.imagePreview = file.name
            this.errorImg=false
        };
        reader.readAsDataURL(file);
      }
    },
    async NextStep(){
      console.log(this.userRegister)
      this.try_step = this.step
      switch(this.step){
        case 1:
          if(this.userRegister.name.length>0 && this.userRegister.surname.length>0 && this.phone_regex.test(this.userRegister.mobile_phone)){
            this.transitionDirection = "slide-forward"
            this.step++
          }
          break
        case 2:
          if(this.userRegister.birthday_date!=null && new Date(this.userRegister.birthday_date) < new Date()){
            this.transitionDirection = "slide-forward"
            this.step++
          }
          break
        case 3:
        if(this.email_regex.test(this.userRegister.email) && this.userRegister.password.length >= 8 && this.password_repeted==this.userRegister.password){
            this.Register()
          }
          break
        default:
          return;
      }
    },
    async Register(){
      var spinner = document.getElementById("spinner")
      spinner.classList.remove("d-none")

      const apiUrl = process.env.VUE_APP_API_URL+'/api/users';

      axios.post(apiUrl, this.userRegister)
      .then(response => {
        this.$store.dispatch('setToken', response.data);
        spinner.classList.add("d-none")
        this.transitionDirection = "slide-forward"
        this.step++
        setTimeout(() => {
          router.push({ name: "home" });
        }, 3000);
      })
      .catch(error => {
        console.error(error);
        this.error = true
        spinner.classList.add("d-none")
      });
    },
  }
}

</script>

<style scoped>

.container {
    display: flex;
    flex-direction: column;
    height: 100vh; /* Ocupa toda la altura de la ventana */
  }

/* Transición hacia adelante */
.slide-forward-enter-active {
  animation: slideInRight 1s;
}
.slide-forward-leave-active {
  animation: slideOutLeft 1s;
}

/* Transición hacia atrás */
.slide-backward-enter-active {
  animation: slideInLeft 1s;
}
.slide-backward-leave-active {
  animation: slideOutRight 1s;
}

/* Animaciones */
@keyframes slideInRight {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
}

@keyframes slideOutLeft {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-100%);
  }
}

@keyframes slideInLeft {
  from {
    transform: translateX(-100%);
  }
  to {
    transform: translateX(0);
  }
}

@keyframes slideOutRight {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(100%);
  }
}

.circle {
  width: 200px; /* Tamaño del círculo */
  height: 200px;
  background-color: #E3E5E9; /* Color de fondo gris */
  border-radius: 50%; /* Hace que el contenedor sea circular */
  display: flex; /* Flexbox para centrar contenido */
  justify-content: center; /* Centrar horizontalmente */
  align-items: center; /* Centrar verticalmente */
  overflow: hidden; /* Ocultar cualquier desbordamiento */
  position: relative; /* Para posibles personalizaciones futuras */
}

.circle img {
  max-width: 20%; /* Ajusta el tamaño de la imagen */
  object-fit: contain; /* Escala la imagen sin deformarla */
}

  .form-floating > label{
    color: #8E97A7 !important
  }

  .form-control{
    border: 0px;
    border-radius: 12px;
  }

  .modal {
    background: rgba(139, 139, 139, 0.5);
  }
  .modal-dialog {
    min-height: 90vh;
  }


</style>
